import React from "react";
import {useQuery} from "@apollo/client";
import {GET_ALL_NEWS} from "../../../../AdminPart/GraphQL/queries/OnlyHereQueries";
import CompanyNewsSourceGatsby from "./news";

function QueryAllNews(props) {
    const { loading, error, data } = useQuery(GET_ALL_NEWS);
    if (loading) return 'Loading...';
    if (error) return `Error! ${error.message}`;
    //console.log('datadata',data.getAllNews);
    const getAllNewsForSort = [...data.getAllNews]
    return <CompanyNewsSourceGatsby PrerenderTexts={props.PrerenderTexts} ArrayOfAllNews={getAllNewsForSort.sort((a, b) => (a.NewsDate > b.NewsDate) ? -1 : 1)} lang={props.lang} data = {props}/>;
}

export default QueryAllNews
